import { render, staticRenderFns } from "./DetailedDropdown.vue?vue&type=template&id=12a628cc&"
import script from "./DetailedDropdown.vue?vue&type=script&lang=js&"
export * from "./DetailedDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DetailedDropdown.vue?vue&type=style&index=0&id=12a628cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports